import { MstRegistration, MstRegistrationRaw } from '@libs/templates/mst';

/*
 * MstRegistrationと同内容だが、MstMaintenanceTmplにおいてサブクラスが必要なため実装
 */
class CustomMstRegistration extends MstRegistration {
  private constructor(mstRegistration: MstRegistration) {
    super(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      mstRegistration.validityStartDate,
      mstRegistration.validityEndDate,
      mstRegistration.mstNote,
    );
  }

  static init(code?: string) {
    return new CustomMstRegistration(MstRegistration.baseInit(code));
  }

  static fromRaw(raw: CustomMstRegistrationRaw) {
    return new CustomMstRegistration(MstRegistration.baseFromRaw(raw));
  }
}

class CustomMstRegistrationRaw extends MstRegistrationRaw {
  private constructor(mstRegistrationRaw: MstRegistrationRaw) {
    super(
      mstRegistrationRaw.id,
      mstRegistrationRaw.version,
      mstRegistrationRaw.code,
      mstRegistrationRaw.name,
      mstRegistrationRaw.mstSpareName01,
      mstRegistrationRaw.mstSpareName02,
      mstRegistrationRaw.validityStartDate,
      mstRegistrationRaw.validityEndDate,
      mstRegistrationRaw.mstNote,
    );
  }

  static fromModel(customMstRegistration: CustomMstRegistration) {
    return new CustomMstRegistrationRaw(MstRegistrationRaw.baseFromModel(customMstRegistration));
  }
}

export { CustomMstRegistration, CustomMstRegistrationRaw };
